import { createFileRoute } from '@tanstack/react-router';

import { MessageComposer } from '~/components/message-composer';

export const Route = createFileRoute('/_dashboard/mailbox/new-message')({
  component: NewMessageMailboxRoute,
});

function NewMessageMailboxRoute() {
  return (
    <div className="h-full min-w-0 overflow-auto bg-background">
      <MessageComposer mode="new" />
    </div>
  );
}
